<template>
  <div class="order_deail">
    <div class="order_left">
      <el-form :inline="true" :model="formInline" class="form">
        <el-form-item label="订单号查询">
          <el-input v-model="formInline.orderOn" placeholder="订单号查询"></el-input>
        </el-form-item>
        <el-form-item label="门店列表">
          <!-- <el-input v-model="formInline.user" placeholder="门店列表"></el-input> -->
          <el-select v-model="formInline.store_id" filterable placeholder="门店列表">
            <el-option
              v-for="item in roomList"
              :key="item.id"
              :label="item.room_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名称">
          <el-input v-model="formInline.user" placeholder="用户名称"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <!-- <el-input v-model="formInline.user" placeholder="手机号"></el-input> -->
          <el-select v-model="formInline.mobile" filterable placeholder="手机号" clearable>
            <el-option
              v-for="item in optionsMobile"
              :key="item.mobile"
              :label="item.mobile"
              :value="item.mobile"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList" class="form_btn">
            <img src="../assets/static/query.png" class="btn_img" />查询
          </el-button>
        </el-form-item>
      </el-form>
      <div class="order_detail">
        <div class="order_type">订单状态:</div>
        <div
          class="order_type_detail"
          v-for="item in orderTypeList"
          :key="item.id"
          :class="orderTypeIndex == item.id ? 'order_type_change': ''"
          @click="orderTypeChange(item.id,1)"
        >{{item.title}}</div>
      </div>
      <div class="order_detail">
        <div class="order_type">订单来源:</div>
        <div
          class="order_type_detail"
          v-for="item in orderSourceList"
          :key="item.id"
          :class="orderSourceIndex == item.id ? 'order_type_change': ''"
          @click="orderTypeChange(item.id,2)"
        >{{item.title}}</div>
      </div>
      <div class="order_detail" style=" border-bottom: 1px solid #051238;padding-bottom: 40px">
        <div class="order_type">标记时间:</div>
        <div
          v-for="item in makeTimeList"
          :key="item.id"
          :class="makeTimeIndex == item.id ? 'order_type_change order_type_detail': 'order_type_detail'"
          @click="orderTypeChange(item.id,3)"
        >
          <div v-if="item.id !=5">{{item.title}}</div>
        </div>
        <!-- <el-date-picker
          v-model="orderDate"
          type="date"
          placeholder="指定日期"
          class="order_type_detail"
          style="padding-right: 0;"
        ></el-date-picker>-->
        <div :class="makeTimeIndex == 5 ? 'order_type_change': ''">
          <el-date-picker
            v-model="orderDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @blur="dataFcous"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
      </div>
      <div class="sorting">
        <div class="export_btn" style="margin-right: 20px;">导出</div>
        <div class="export_btn">时间正序</div>
        <div class="export_btn" style="border-left: 0;border-radius: 0 4px 4px 0;">时间倒序</div>
      </div>
      <div class="table_list" style="flex-grow: 1;overflow-y: scroll;" ref="tableRef">
        <el-table
          :data="tableData"
          border
          :height="tableData.length > 0 ? tableHeight : ''"
          :row-style="tableRowStyle"
        >
        <!--  -->
          <!-- :row-class-name="tableRowClassName" -->

          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" prop="id" label="id"></el-table-column>
          <el-table-column align="center" prop="room_name" label="门店名称" width="160"></el-table-column>
          <el-table-column align="center" prop="create_time" label="时间" width="180"></el-table-column>
          <el-table-column align="center" prop="nickname" label="用户名"></el-table-column>
          <el-table-column align="center" prop="mobile" label="手机号" width="126"></el-table-column>
          <el-table-column align="center" prop="order_on" label="订单号" width="300"></el-table-column>
          <el-table-column align="center" prop="platform_type_name" label="订单来源" width="120" v-if="typeNew == 2 "></el-table-column>
          <el-table-column align="center" prop="type" label="异常类型" width="120" v-if="typeNew == 1 || typeOeder == -1" ></el-table-column>
          <el-table-column align="center" prop="add_time" label="处理时间" width="120" v-if="typeNew == 1 || typeOeder == -1"></el-table-column>
          <el-table-column align="center" prop="status" label="是否处理" width="96">
            <template slot-scope="scope">
              <img
                src="../assets/static/inspectionOpen.png"
                alt
                v-if="scope.row.status == 1"
                @click="changeBtn(scope.row)"
                style="width: 72px;"
              />
              <img
                v-if="scope.row.status == 0"
                src="../assets/static/inspectionClose.png"
                alt
                @click="changeBtn(scope.row)"
                style="width: 72px;"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" prop="zip" label="异常类型" width="120"></el-table-column> -->
          <el-table-column align="center" fixed="right" label="操作" width="322">
            <template slot-scope="scope">
              <el-button @click="handleClickVideo(scope.row)" type="text" class="right_btn">视频回放</el-button>
              <el-button @click="handleClick(scope.row)" type="text" class="right_btn">查看订单</el-button>
              <el-button
                @click="handleClickHandle(scope.row)"
                type="text"
                class="right_btn right_btn_color_big"
              >{{scope.row.status == 0 ? "立即处理" : '处理结果'}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalOrder"
        class="pagination"
      ></el-pagination>
    </div>
    <div class="order_right">
      <div class="order_right_top">订单详情</div>
      <div class="over_flow_style">
        <div class="shop_detail">
          <div class="shop_box" v-for="(item,index) in detailDate.goods" :key="index">
            <div class="shop_info">
              <img :src="item.photos" alt class="shop_img" />
            </div>
            <div style="flex-grow: 1;margin-left:7px;font-size: 14px;">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <div>
                  <div class="shop_specification">{{item.name}}</div>
                  <div>UPC:{{ item.ucp }}</div>
                </div>
                <div>x{{ item.num }}</div>
              </div>
              <div class="shop_price">
                <div>货架：{{ item.shelf_number }}</div>
                <div>￥{{item.price}}元</div>
              </div>
            </div>
          </div>
        </div>
        <div class="shop_num" v-if="detailDate.goods != undefined">共计{{detailDate.order.num}}件</div>
        <div class="order_price">
          <div style="font-weight: 600;font-size: 20px;margin-bottom: 20px">订单金额</div>
          <div class="price_type">
            <div>支付方式</div>
            <div v-if="detailDate.order!=undefined">{{detailDate.order.pay_type}}</div>
            <!-- <div v-if="detailDate.order!=undefined && detailDate.order.pay_type == 0">未支付</div>
            <div v-if="detailDate.order!=undefined && detailDate.order.pay_type == 1">微信支付</div>
            <div v-if="detailDate.order!=undefined && detailDate.order.pay_type == 2">支付宝</div> -->
          </div>
          <div class="price_type">
            <div>顾客实付</div>
            <div
              style="color: #FF901Ds;"
              v-if="detailDate.order!=undefined"
            >{{detailDate.order.user_fee}}元</div>
          </div>
          <div class="price_type">
            <div>优惠金额</div>
            <div
              style="color: #FF901Ds;"
              v-if="detailDate.order!=undefined"
            >{{detailDate.order.discount_fee}}元</div>
          </div>
          <div class="price_type">
            <div>平台结算</div>
            <div
              style="color: #FF901Ds;"
              v-if="detailDate.order!=undefined"
            >{{detailDate.order.order_receivable_amount}}元</div>
          </div>
          <div class="price_type">
            <div>订单原价</div>
            <div
              style="color: #FF901Ds;"
              v-if="detailDate.order!=undefined"
            >{{detailDate.order.order_original_amount}}元</div>
          </div>
          <!-- <div class="price_type">
            <div>商家实收</div>
            <div v-if="detailDate.order!=undefined">{{detailDate.order.original_price}}元</div>
          </div> -->
        </div>
        <div class="order_price" style="border: 0;">
          <div style="font-weight: 600;font-size: 20px;margin-bottom: 20px">订单信息</div>
          <div class="price_type">
            <div>下单时间</div>
            <div v-if="detailDate.order!=undefined">{{detailDate.order.create_time}}</div>
          </div>
          <div class="price_type">
            <div>平台订单</div>
            <div v-if="detailDate.order!=undefined">{{detailDate.order.order_on}}</div>
          </div>
        </div>
        <div class="order_price" v-if="typeOeder == 2">
          <div style="font-weight: 600;font-size: 20px;margin-bottom: 20px">骑手信息</div>
          <div class="price_type">
            <div>配送单号</div>
            <div v-if="detailDate.rider!=undefined">{{detailDate.rider.delivery_sn}}</div>
          </div>
          <div class="price_type">
            <div>骑手姓名</div>
            <div v-if="detailDate.rider!=undefined">{{detailDate.rider.knight_name}}</div>
          </div>
          <div class="price_type">
            <div>骑手手机号</div>
            <div v-if="detailDate.rider!=undefined">{{detailDate.rider.knight_phone}}</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="处理结果"
      :visible.sync="dialogVisibleTakeout"
      width="50%"
      :before-close="handleClose"
    >
      <el-input
        type="textarea"
        :rows="4"
        placeholder="请输入处理结果"
        v-model="contentNew"
        :disabled="contentFlag"
        style="background: #1c437d !important"
      ></el-input>
      <div class="mark_pop_btn">
        <div class="mark_pop_left" @click="submitMake(2)" style="background:transparent;">取消</div>
        <div class="mark_pop_left" @click="submitMake(1)" v-if="!contentFlag">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  roomList,
  UserMobile,
  TagUserData,
  handle,
  detailOrder
} from "@/utils/api/index";

export default {
  name: "orderList",
  // typeOeder 1稽查订单 2查询订单 orderDetailId订单号
  props: ["typeOeder", "roomId",'orderDetailId'],
  data() {
    return {
      typeNew: "",
      contentNew: "",
      contentId: "",
      contentFlag: false,
      dialogVisibleTakeout: false,
      detailOrder: "",
      detailDate: {},
      formInline: {
        orderOn: "",
        store_id: "",
        user: "",
        mobile: ""
      },
      roomList: [],
      optionsMobile: [],
      orderTypeList: [
        {
          id: 2,
          title: "全部"
        },
        {
          id: 0,
          title: "未处理"
        },
        {
          id: 1,
          title: "已处理"
        }
      ],

      orderTypeIndex: 2,
      orderSourceList: [
        {
          id: 0,
          title: "全部"
        },
        {
          id: 1,
          title: "线下订单"
        },
        {
          id: 2,
          title: "美团订单"
        },
        {
          id: 3,
          title: "饿了么零售"
        },
        {
          id: 4,
          title: "京东到家"
        }
      ],
      orderSourceIndex: 0,
      makeTimeList: [
        {
          id: 1,
          title: "今日"
        },
        {
          id: 2,
          title: "昨天"
        },
        {
          id: 3,
          title: "本周"
        },
        {
          id: 4,
          title: "本月"
        }
        // {
        //   id: 5,
        //   title: "指定日期"
        // }
      ],
      orderDate: "",
      makeTimeIndex: 1,
      currentPage: 1,
      tableData: [],
      tableHeight: 200,
      pageSize: 10,
      totalOrder: 0
    };
  },
  async created() {
    this.formInline.store_id = this.roomId;

    this.formInline.orderOn = this.orderDetailId

    await this.getRoomList();
    await this.getUserMobile();
    await this.getList()
    this.$nextTick(() => {
      const div = this.$refs.tableRef;
      this.tableHeight = div.offsetHeight - 46;
      this.typenNew = this.typeOeder == -1 ? 2 : this.typeOeder;
      console.log(this.typeOeder,this.typenNew,'this.typeOederthis.typeOederthis.typeOeder')

    });
  },
  mounted() {
    this.$nextTick(() => {
      const div = this.$refs.tableRef;
      this.tableHeight = div.offsetHeight - 46;
    });
  },
  watch: {
    typeOeder(oldT, newT) {
      console.log(newT, "newTnewTnewT");
      if (oldT != -1) {
        if (oldT != -1) {
          this.typeNew = oldT == -1 ? 2 : oldT;
          console.log(this.typeNew,'this.typeNewthis.typeNew')
        }
        this.getList();
        this.getRoomList();
        // if (this.formInline.store_id == "") {
        //   this.getRoomList();
        // } else {
        //   this.getList();
        //   this.getRoomList();

        // }
      }
    }
  },
  methods: {
    handleClose() {
      this.dialogVisibleTakeout = false;
    },
    submitMake(type) {
      if (type == 2) {
        this.dialogVisibleTakeout = false;
      }
      if (type == 1) {
        handle({
          id: this.contentId,
          content: this.contentNew
        }).then(res => {
          console.log("88888", res);
          this.getList();
          this.dialogVisibleTakeout = false;
        });
      }
    },
    handleClick(row) {
      if (row.order_on == "") {
        this.$message.success("暂无详情");
        return;
      }
      this.detailOrder = row.order_on;
      this.getDetail();
    },
    handleClickHandle(row) {
      this.contentNew = row.content;
      this.contentId = row.id;
      if (row.status != 0) {
        this.contentFlag = true;
      } else {
        this.contentFlag = false;
      }
      this.dialogVisibleTakeout = true;
    },
    handleClickVideo(row) {
      this.$emit("clickVideoReplay", {
        type: 3,
        row
      });
    },
    getList() {
      console.log(
        this.formInline.store_id,
        "this.formInline.store_idthis.formInline.store_id"
      );
      TagUserData({
        id: this.formInline.store_id,
        page: this.currentPage,
        limit: this.pageSize,
        status: this.orderTypeIndex == 2 ? undefined : this.orderTypeIndex,
        type: this.typeOeder == -1 ? 1 : this.typeOeder,
        nickname: this.formInline.user,
        mobile: this.formInline.mobile,
        order_on: this.formInline.orderOn,
        type_status: this.orderSourceIndex,
        type_time: this.makeTimeIndex,
        add_time: this.makeTimeIndex == 5 ? this.orderDate[0] : undefined,
        end_time: this.makeTimeIndex == 5 ? this.orderDate[1] : undefined
      }).then(res => {
        this.totalOrder = res.data.count;
        this.tableData = res.data.order;
        if (res.data.order != undefined && this.tableData.length > 0) {
          for (let index = 0; index < this.tableData.length; index++) {
            if (this.tableData[index].order_on != "") {
              this.detailOrder = this.tableData[index].order_on;
              break;
            }
          }
          if (this.detailOrder != "") {
            this.detailDate = []
            this.getDetail();
          }
        }
      });
    },
    dataFcous() {
      console.log(this.orderDate == "", "orderDateorderDateorderDate");
      if (this.orderDate != "") {
        this.makeTimeIndex = 5;
        this.getList();
      }
    },
    getDetail() {
      detailOrder({
        order_on: this.detailOrder
      }).then(res => {
        this.detailDate = res.data;
      });
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getList();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getList();
    },
    getRoomList(type) {
      if(type==1) {
        this.totalOrder = 0;
        this.tableData = [];
      }
      roomList({
        name: this.nameTop
      }).then(res => {
        this.roomList = res.data;
        if (this.formInline.store_id == "") {
          // this.formInline.store_id = res.data[0].id;
        }
        // this.getList();
      });
    },
    getUserMobile() {
      UserMobile({
        is_block: 0
      }).then(res => {
        this.optionsMobile = res.data;
      });
    },
    // handleSizeChange(e) {
    //   console.log(e, "size");
    // },
    // handleCurrentChange(e) {
    //   console.log(e, "current");
    // },
    onSubmit() {},
    orderTypeChange(item, type) {
      if (type == 1) {
        this.orderTypeIndex = item;
      }
      if (type == 2) {
        this.orderSourceIndex = item;
      }
      if (type == 3) {
        this.makeTimeIndex = item;
        this.orderDate = "";
      }
      this.getList();
    },
    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
      //   return "";
    },
    tableRowStyle({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return {
          background: "#16264a"
        };
      } else {
        return {
          background: "#0d193c"
        };
      }
    }
  }
};
</script>
<style scoped lang="scss">
:deep(.el-dialog__body) {
  background: #213456;
}
:deep(.el-textarea__inner) {
  font-size: 13px;
  color: #e6e9eb;
  background: #1c437d !important;
  border: 1px solid #e6e9eb !important;
}
.mark_pop_btn {
  display: flex;
  justify-content: end;
  margin-top: 20px;
  .mark_pop_left {
    width: 60px;
    height: 28px;
    background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
    border-radius: 4px;
    border: 1px solid #e6e9eb;
    line-height: 28px;
    text-align: center;
    font-weight: 400;
    font-size: 15px;
    color: #ffffff;
    margin-right: 10px;
  }
}
.order_deail {
  // background: #051238;
  display: flex;
  justify-content: space-between;
  height: calc(100% - 54px);
  padding: 10px;
  box-sizing: border-box;
  .order_left {
    width: 78%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #213456;
    padding: 26px 30px;
    box-sizing: border-box;
    .form {
      color: #d4e6ff !important;
      :deep(.el-form-item__label) {
        font-size: 14px;
        color: #d4e6ff;
      }
      :deep(.el-input__inner) {
        height: 36px;
        background: #051238;
        border-radius: 2px;
        color: #ffffff;
      }
      .form_btn {
        width: 90px;
        height: 36px;
        background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
        border-radius: 4px;
        border: 1px solid #5fbcf5;
        .btn_img {
          width: 16px;
          vertical-align: middle;
          margin-right: 6px;
        }
      }
    }
    .order_detail {
      display: flex;
      align-items: center;
      margin-bottom: 28px;
      flex-wrap: wrap;
      :deep(.el-date-editor .el-range-separator) {
        // display: none;
        color: #fff;
      }
      :deep(.el-date-editor .el-range-input) {
        width: 50%;
      }
      :deep(.el-range-editor .el-range-input) {
        background: transparent;
        color: #fff;
        font-size: 18px;
      }
      .popper-class {
        background-color: #051238;
      }
      .order_type {
        font-size: 16px;
        color: #d4e6ff;
      }
      :deep(.el-input__inner) {
        height: 32px;
        background-color: transparent;
        border: 0;
        font-weight: 400;
        font-size: 18px;
        padding: 0;
        color: #ffffff;
      }
      :deep(.el-input__icon) {
        display: none;
      }
      .order_type_detail {
        height: 32px;
        border-radius: 4px;
        line-height: 32px;
        padding: 0 20px;
        font-size: 18px;
        color: #ffffff;
        margin: 0 18px;
        border: 1px solid transparent;
      }
      .order_type_change {
        border: 1px solid #3dc1ff;
        background: #29456e;
      }
    }
    .sorting {
      display: flex;
      align-items: center;
      height: 90px;
      background: #29456e;
      margin-top: 35px;
      padding-left: 30px;
      box-sizing: border-box;
      .export_btn {
        height: 32px;
        background: #29456e;
        border-radius: 4px;
        border: 1px solid #3dc1ff;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        line-height: 32px;
        padding: 0 20px;
      }
    }
    .right_btn {
      width: 90px;
      height: 36px;
      background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
      border-radius: 4px;
      border: 1px solid #5fbcf5;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      padding-bottom: 28px;
    }
    .right_btn_color {
      background: linear-gradient(180deg, #a9801d 0%, #b56625 100%);
      border-radius: 4px;
      border: 1px solid #fcd486;
    }
    .right_btn_color_big {
      background: linear-gradient(180deg, #0e6871 0%, #25b587 100%);
      border-radius: 4px;
      border: 1px solid #5fbcf5;
    }
    .el-pagination {
      text-align: center;
      margin-top: 24px;
      margin-bottom: 14px;
    }
    .pagination {
      :deep(.el-pagination__total) {
        font-size: 18px;
        color: rgba(255, 255, 255, 0.88);
        margin-top: 4px;
      }
      :deep(.el-input__inner) {
        background: #051238;
        border-radius: 6px;
        font-size: 16px;
        color: #cccccc;
        border: 0;
        margin-top: 4px;
      }
      :deep(.btn-prev) {
        width: 36px;
        height: 36px;
        background: #29456e;
        border-radius: 7px;
      }
      :deep(.el-pager li) {
        width: 36px;
        height: 36px;
        border-radius: 7px;
        background: #29456e;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #ffffff;
        line-height: 36px;
        font-size: 18px;
        border-radius: 7px;
        margin: 0 5px;
      }
      :deep(.btn-next) {
        width: 36px;
        height: 36px;
        background: #29456e;
        border-radius: 7px;
      }
      :deep(.el-pagination__jump) {
        font-size: 18px;
        margin-top: 4px;
      }
      :deep(.el-pager li.active) {
        background: linear-gradient(
          180deg,
          #0e3671 0%,
          #2571b5 100%
        ) !important;
        border: 1px solid #5fbcf5;
      }
    }
  }
  // 表格样式
  .table_list::-webkit-scrollbar {
    width: 3px !important; /* 滚动条宽度 */
  }
  .el-table {
    background-color: #0d193c;
    border: 1px solid #2f416b;
  }
  :deep(thead .el-table__cell) {
    background-color: #16264a;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
  }
  :deep(.el-table__fixed-right-patch) {
    background: #213456 !important;
  }
  :deep(.el-table__body tr.hover-row > td) {
    background-color: transparent !important;
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background: transparent;
  }

  .el-table__fixed-right::before,
  .el-table__fixed::before {
    background: transparent !important;
  }

  .order_right {
    width: 19%;
    height: 100%;
    background: #213456;
    // overflow-y: scroll;
    .over_flow_style {
      height: calc(100% - 43px);
      overflow-y: scroll;
    }

    .order_right_top {
      width: 100%;
      height: 43px;
      background-image: url(../assets/static/shopbg.png);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      font-weight: 600;
      font-size: 20px;
      color: #ffffff;
      padding-left: 37px;
      line-height: 43px;
      box-sizing: border-box;
    }
    /* 自定义滚动条样式 */
    .shop_detail::-webkit-scrollbar {
      width: 3px !important; /* 滚动条宽度 */
    }
    .shop_detail {
      height: 30%;
      overflow-y: scroll;
      margin: 10px;
      font-size: 16px;
      color: #ffffff;

      .shop_box {
        display: flex;
        align-items: center;
        padding: 10px;

        .shop_info {
          display: flex;
          .shop_img {
            width: 52px;
          }
        }
        .shop_specification {
          font-size: 16px;
          margin-bottom: 6px;
        }
        .shop_price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #ff901d;
        }
      }
    }
    .shop_num {
      font-size: 20px;
      color: #ffffff;
      padding-left: 20px;
      margin-top: 2%;
      margin-bottom: 6%;
    }
    .order_price {
      margin: 0px 20px;
      padding-top: 20px;
      padding-bottom: 20px;
      border-top: 1px solid #051238;
      border-bottom: 1px solid #051238;
      color: #ffffff;
      font-size: 16px;
      .price_type {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 36px;
      }
    }
    .order_info {
      margin: 0px 20px;
      padding-top: 6%;
      padding-bottom: 8%;
      color: #ffffff;
    }
  }
}
</style>
